var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 4C8.5 1.79086 10.2909 0 12.5 0H36.5C38.7091 0 40.5 1.79086 40.5 4V12H8.5V4ZM13.5 3C12.3954 3 11.5 3.89543 11.5 5V9H37.5V5C37.5 3.89543 36.6046 3 35.5 3H13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 14H40.5V36H8.5V14ZM11.5 17H37.5V33H11.5V17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 38H8.5V46C8.5 47.1046 9.39543 48 10.5 48H38.5C39.6046 48 40.5 47.1046 40.5 46V38ZM11.5 41H37.5V44C37.5 45.1046 36.6046 45 35.5 45H13.5C12.3954 45 11.5 45.1046 11.5 44V41Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6C20.5 5.44772 20.9477 5 21.5 5H27.5C28.0523 5 28.5 5.44772 28.5 6C28.5 6.55228 28.0523 7 27.5 7H21.5C20.9477 7 20.5 6.55228 20.5 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryOutlined);
export default __webpack_public_path__ + "static/media/inventory_outlined.7e1854ec3ce01d3969c337c342db9aad.svg";
export { ForwardRef as ReactComponent };